// extracted by mini-css-extract-plugin
export default {"cmodal":"deletepass_cmodal__mZfnh","Subtitle":"deletepass_Subtitle__2aqkY"};